import React, { useEffect } from "react";
import { RESOURCE_GATED_CTA_TEXT, RESOURCE_GATED_MESSAGE } from "@qlik/qlik/src/lib/constants/resource-constants";
import { TYPE_MARKETO_FORM } from "@qlik/qlik/src/lib/constants/contentful-types";
import { getMicrocopyValueFromKeys } from "@qlik/qlik/src/lib/util/helpers";

const findFormCard = (cardItems) => cardItems?.find((card) => card.__typename === TYPE_MARKETO_FORM);

/**
 * Component to render for Download Thank You - a successful gated form submission
 * for a Gated Resource or a download of an Ungated Resource.
 *
 * @param {Object} data - The data to be displayed.
 * @returns {JSX.Element} Inner page elements.
 */
const FormSuccessFeedback = ({ data, downloadable }) => {
    const { components = [] } = data ?? {};
    // extract thank you message from marketo form
    const formCardComponent = components?.find((component) => findFormCard(component.cardItems));
    const formCard = findFormCard(formCardComponent.cardItems);
    const thankYouMessage = formCard?.thankYouMessage;

    const resourceUrl = downloadable?.internalLink?.asset
        ? downloadable?.internalLink?.asset[0]?.original_secure_url
        : downloadable?.externalUrl;

    useEffect(() => {
        if (window) {
            window.scrollTo(0, 0);
        }
    }, []);

    const [gatedCtaText, gatedDefaultMessage] = getMicrocopyValueFromKeys(data?.microcopyGroup, [
        RESOURCE_GATED_CTA_TEXT,
        RESOURCE_GATED_MESSAGE,
    ]);

    return (
        <section className="py-20 lg:py-30 contain-paint">
            <div
                className="container relative
                            before:-z-1 before:content-[''] before:absolute before:w-[1408px] before:h-137.5 before:bg-thankYou before:bg-contain before:-top-72 before:-right-[1000px] 
                            lg:before:-top-[120px] lg:before:-right-[830px]"
            >
                <div className="row">
                    <div className="col-12 md:col-6">
                        <h1 className="title-1">{thankYouMessage || gatedDefaultMessage}</h1>
                        {data?.title && (
                            <p className="mt-7.5 text-2xl font-light leading-relaxed tracking-tight6">{data?.title}</p>
                        )}

                        <a
                            href={resourceUrl}
                            rel="noreferrer"
                            target="_blank"
                            className="btn-primary-large mt-12 cursor-pointer"
                        >
                            {gatedCtaText}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FormSuccessFeedback;
